<template>
  <component
    v-for="(component, index) in content"
    :is="componentsMap[component.fields.component]"
    v-bind="component.fields"
    :key="`${component.fields.component}-${index}`"
    data-testid="render-content"
    :class="['className' in component.fields && component.fields.className]"
  />
</template>

<script setup lang="ts">
import type { RenderContentProps } from '~/components/RenderContent/types';
import BannersSlider from './BannersSlider/BannersSlider.vue';
import ProductsSlider from './ProductsSlider/ProductsSlider.vue';
import HeroBanner from './HeroBanner/HeroBanner.vue';
defineProps<RenderContentProps>();

const componentsMap = computed(() => ({
  Set_Components_BannersSlider: BannersSlider,
  Set_Components_ProductsSlider: ProductsSlider,
  Set_Components_HeroBanner: HeroBanner
}));
</script>
